<!-- 51Talk -->
<template>
  <div class="img_container">
    <!-- 图片宽度100%高度自适应，外层div居中可以使得图片自适应div容器大小 -->
    <img title="CEJ level学习攻略" :src= "url">
  </div>
</template>

<script>
export default {
  name: 'LevelPlan',
  data () {
    return {
      url: ''
    }
  },
  created: function() {
    let level_id = this.$route.params.id
    this.url = "../../../static/images/levelplan/level" +level_id + "_plan.jpg"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  color: #555;
  margin-left: auto;
  margin-right: auto;
  line-height: 20px;
  font-size: 14px;
  font-family: 微软雅黑, sans-serif;
  text-indent: 28px;
  line-height: 1.6
}

.img_container{
  display:flex;
  align-items:center;
  justify-content:center;
}

@media screen and (max-width: 3600px) {
  body {
    width: 550px;
  }
}

img {
  max-width: 100%;
  height: auto;
}

@media screen and (max-width: 500px) {
  body {
    width: 98%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parentread/LevelPlan.vue